import React from "react";
import styled from "styled-components";

const data = [
  {
    especialidades: "PF",
    tipo: "Enfermagem",
    setor: "Internato Médico",
    turma: "3A",
    numAlunos: 3,
    totalAlunosInst: 40,
    numHoras: "200h",
    totalHorasAlunosUnid: "600h",
    status: "✅",
  },
  {
    especialidades: "PF",
    tipo: "Enfermagem",
    setor: "Internato Médico",
    turma: "Clínica Médica",
    numAlunos: 5,
    totalAlunosInst: 35,
    numHoras: "240h",
    totalHorasAlunosUnid: "1200h",
    status: "✅",
  },
  {
    especialidades: "PF",
    tipo: "Enfermagem",
    setor: "Internato Médico",
    turma: "UTI",
    numAlunos: 6,
    totalAlunosInst: 30,
    numHoras: "300h",
    totalHorasAlunosUnid: "1800h",
    status: "✅",
  },
  {
    especialidades: "PE",
    tipo: "Medicina",
    setor: "Estág. Eletivo",
    turma: "5A",
    numAlunos: 5,
    totalAlunosInst: 48,
    numHoras: "120h",
    totalHorasAlunosUnid: "480h",
    status: "✅",
  },
  {
    especialidades: "PL",
    tipo: "Enfermagem",
    setor: "Estág. Obrigatório",
    turma: "3b",
    numAlunos: 8,
    totalAlunosInst: 20,
    numHoras: "300h",
    totalHorasAlunosUnid: "2400h",
    status: "✅",
  },
  {
    especialidades: "PP",
    tipo: "Odontologia",
    setor: "Aula Prática",
    turma: "Clínica Médica",
    numAlunos: 4,
    totalAlunosInst: 30,
    numHoras: "160h",
    totalHorasAlunosUnid: "640h",
    status: "✅",
  },
];

// Estilos da tabela
const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  font-family: Public-Sans;
  font-size: 12px;
`;

const TableHeader = styled.th`
  background-color: #f2f0f0;
  padding: 5px;
  border: 1px solid #ddd;
  font-weight: bold;
  color: #6AB8A8;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: rgba(120, 216, 196, 0.2); 
  }
`;

const TableCell = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
`;

const StatusCell = styled.td`
  padding: 10px;
  border: 1px solid #ddd;
  color: green;
  font-weight: bold;
`;

// Componente da Tabela
const Table = () => {
  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <TableRow>
            <TableHeader>ESPECIALIDADES</TableHeader>
            <TableHeader>TIPO</TableHeader>
            <TableHeader>SETOR</TableHeader>
            <TableHeader>TURMA</TableHeader>
            <TableHeader>Nº ALUNOS</TableHeader>
            <TableHeader>Nº TOTAL / ALUNOS INST.</TableHeader>
            <TableHeader>Nº HORAS</TableHeader>
            <TableHeader>Nº TOTAL / HORAS ALUNOS POR UNID.</TableHeader>
            <TableHeader>STATUS</TableHeader>
          </TableRow>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{row.especialidades}</TableCell>
              <TableCell>{row.tipo}</TableCell>
              <TableCell>{row.setor}</TableCell>
              <TableCell>{row.turma}</TableCell>
              <TableCell>{row.numAlunos}</TableCell>
              <TableCell>{row.totalAlunosInst}</TableCell>
              <TableCell>{row.numHoras}</TableCell>
              <TableCell>{row.totalHorasAlunosUnid}</TableCell>
              <StatusCell>{row.status}</StatusCell>
            </TableRow>
          ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export default Table;